
import { setTasks, moveTask, addTask } from '../redux/actions';

// Drag&Drop functions
export const useDragAndDrop = (state, dispatch) => {

    const onDragEnd = result => {
        const { destination, source } = result;

        if (!destination) {
            return;
        }

        if (destination.droppableId === source.droppableId) {

            if (destination.index === source.index) {
                return;
            }
            const tasks = state.editor.test.tasks;
            let newTasks = Array.from(tasks);
            const [removedTask] = newTasks.splice(source.index, 1);
            newTasks = [...newTasks.slice(0, destination.index), removedTask, ...newTasks.slice(destination.index)];

            dispatch(moveTask(newTasks));

        } else if (destination.droppableId !== source.doppableId) {
            if (source.droppableId === 'task-list') {
                const selectedTask = state.tasks.tasks[result.source.index];
                dispatch(addTask(selectedTask, result.destination.index));
            } else {
                const sourceGroup = state.editor.test.groups.find(group => group.id === result.source.droppableId);
                const destinationGroup = state.editor.test.groups.find(group => group.id === result.destination.droppableId);
                const selectedTask = sourceGroup.tasks[result.source.index];
                const sourceTasks = [...sourceGroup.tasks.slice(0, result.source.index), ...sourceGroup.tasks.slice(result.source.index + 1)];
                const destinationTasks = [...destinationGroup.tasks.slice(0, result.destination.index), selectedTask, ...destinationGroup.tasks.slice(result.destination.index)];
                dispatch(setTasks(sourceGroup.id, sourceTasks));
                dispatch(setTasks(destinationGroup.id, destinationTasks));
            }
        }
    }

    return { onDragEnd }
}
